import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPhoneVolume,
  faChevronRight,
  faVideoCamera,
} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import useAuth from '../hooks/useAuth'

const NextCounsellingCard = ({ session, onClick }) => {
  const { auth } = useAuth()
  function formatDate(type = 'date') {
    const m = moment(session.start_time)
    if (type === 'date') {
      return m.format('dddd Do MMMM YYYY')
    }
    if (type === 'time') {
      return m.format('h:mm A')
    }
    return ''
  }

  if (!session) {
    return null
  }

  return (
    <div
      className={`bg-white border-l-8 border-l-[#969EF4] shadow-md rounded-xl flex items-center justify-between p-4 max-w-md ${typeof onClick === 'function' ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="pl-2 space-y-2">
        <div>
          <div className='flex gap-2 items-center mb-2'>
            <FontAwesomeIcon
              icon={session.video_session ? faVideoCamera : faPhoneVolume}
              className="text-[#979EF4] text-xl"
            />
            <h3 className="font-semibold text-lg">
              Counselling
            </h3>
          </div>
          <div className='bg-gray-100 rounded-md px-2 py-1 inline-block mb-2 text-sm'>
            <p> For {auth?.user?.name} </p>
          </div>
          <p className="text-sm text-gray-600">
            {formatDate('date')} |{' '}
            {formatDate('time')}
          </p>
        </div>
      </div>
      {typeof onClick === 'function' ? (
        <div className="text-gray-400 text-xl">
          <FontAwesomeIcon
            icon={faChevronRight}
            className="text-[#979EF4] text-xl"
            />
        </div>
      ) : (
        <div className='mr-2'/>
      )}
    </div>
  )
}

export default NextCounsellingCard
